import type { ChangeEvent } from 'react';

export interface StartOverlayProps {
  onStartWebcam: () => Promise<void> | void;
  onVideoFileChange: (event: ChangeEvent<HTMLInputElement>) => Promise<void> | void;
}

export default function StartOverlay({ onStartWebcam, onVideoFileChange }: StartOverlayProps) {
  return (
    <div className="absolute inset-0 flex items-center justify-center bg-black z-10">
      <div className="flex flex-col gap-3 sm:gap-4 items-center px-4 max-w-md w-full">
        <h2 className="text-white text-xl sm:text-2xl font-semibold text-center mb-2">
          Try Moondream with live video
        </h2>
        <button
          onClick={onStartWebcam}
          className="relative inline-flex h-12 overflow-hidden rounded-full p-[1px] focus:outline-none focus:ring-2 focus:ring-slate-400 focus:ring-offset-2 focus:ring-offset-slate-50">
          <span className="absolute inset-[-1000%] animate-[spin_2s_linear_infinite] bg-[conic-gradient(from_90deg_at_50%_50%,#E2CBFF_0%,#393BB2_50%,#E2CBFF_100%)]">
          </span>
          <span className="inline-flex h-full w-full cursor-pointer items-center justify-center rounded-full bg-slate-950 px-3 py-1 text-sm font-medium text-white backdrop-blur-3xl">
            Start Webcam
          </span>
        </button>
        <input
          type="file"
          accept="video/*"
          onChange={onVideoFileChange}
          className="hidden"
          id="video-upload"
        />
        <label
          htmlFor="video-upload"
          className="cursor-pointer text-white/70 hover:text-white text-sm underline transition-colors"
        >
          or choose video
        </label>
      </div>
    </div>
  );
}
